"use strict";
var policy_edit_details_component_1 = require("./policy-edit-details.component");
exports.PolicyEditDetailsComponent = policy_edit_details_component_1.PolicyEditDetailsComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/policy-details/index.js